<template>
    <div class="vmodal">
        <div class="stock-table__wrapper">
            <div class="vmodal__header stock-table__header">
                <h5 class="font-normal text-lg">{{ heading }}</h5>
                <a
                    href="#"
                    class="vmodal__close"
                    @click.prevent="$modal.hideAll()"
                >
                    ×
                </a>
            </div>
            <div class="stock-table__content prose">
                <p v-if="loading">
                    Please wait while we're communicating to our distributors...
                </p>
                <p v-else-if="!rows.length">
                    Sorry, this product is not in stock at the moment. Please contact us directly.
                </p>
                <div v-else class="rounded overflow-hidden border border-xp-line-grey">
                    <table
                        class="stock-table__table"
                    >
                        <thead>
                            <tr>
                                <th class="h-model">
                                    Model name
                                </th>
                                <th class="h-distributor">
                                    Distributor
                                </th>
                                <th class="h-stock">
                                    Quantity
                                </th>
                                <th class="h-link">
                                    Purchase
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row,index) in rows" :key="index">
                                <td
                                    v-if="!index"
                                    :rowspan="rows.length"
                                    class="model"
                                >
                                    {{ modelNumber }}
                                </td>
                                <td class="distributor pl-2">
                                    {{ row.distributor }}
                                </td>
                                <td class="stock">
                                    {{ row.stock }}
                                </td>
                                <td class="link">
                                    <a
                                        v-if="row.stock"
                                        :href="row.link"
                                        class="button button--small"
                                        target="_blank"
                                    >
                                        Buy it now
                                    </a>
                                    <a
                                        v-else
                                        :href="row.link"
                                        class="button button--small button--warning"
                                        target="_blank"
                                    >
                                        Backorder
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'StockCheckModal',
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        modelNumber: {
            type: String,
            required: true,
        }
    },
    data: () => ({
        heading: 'Distributor stock check',
        rows: [],
        loading: true,
    }),
    methods: {
        getRows() {
            // api call to get all relevant stock data for model number
            axios.get(this.endpointWithGetData)
                .then((response) => {
                    this.rows = response.data
                    this.loading = false
                })
        }
    },
    computed: {
        endpointWithGetData() {
            return `${this.endpoint}?model=${this.modelNumber}`
        }
    },
    mounted() {
        this.getRows()
    }
}
</script>
